import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';

import { LLM_MODELS } from '../../constants/Constants';

const CUSTOM_SENTINEL = '__custom__';

const isKnownModel = value => {
  if (!value) return false;
  return LLM_MODELS.some(section => section.some(item => item.value === value));
};

class ModelPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Custom mode is sticky once entered; also auto-enters if value is an unknown non-empty string.
      customMode: !!props.value && !isKnownModel(props.value)
    };
  }

  handleSelectChange = (e, idx, value) => {
    if (value === CUSTOM_SENTINEL) {
      this.setState({ customMode: true });
      this.props.onChange('');
      return;
    }
    this.setState({ customMode: false });
    this.props.onChange(value);
  };

  handleCustomChange = e => {
    this.props.onChange(e.target.value);
  };

  render() {
    const {
      value,
      floatingLabelText,
      hintText,
      fullWidth,
      style,
      disabled,
      id,
      name,
      floatingLabelFixed
    } = this.props;

    const showCustomInput = this.state.customMode || (!!value && !isKnownModel(value));
    const selectValue = showCustomInput ? CUSTOM_SENTINEL : value;

    return (
      <div>
        <SelectField
          id={id}
          name={name}
          value={selectValue}
          onChange={this.handleSelectChange}
          floatingLabelText={floatingLabelText}
          floatingLabelFixed={floatingLabelFixed}
          hintText={hintText}
          fullWidth={fullWidth}
          style={style}
          disabled={disabled}
        >
          {LLM_MODELS.flatMap((section, idx) => {
            const elements = section.map(item => (
              <MenuItem key={item.value} value={item.value} primaryText={item.label} />
            ));
            if (idx > 0) {
              return [<Divider key={`divider-${idx}`} />, ...elements];
            }
            return elements;
          })}
          <Divider key="divider-custom" />
          <MenuItem key={CUSTOM_SENTINEL} value={CUSTOM_SENTINEL} primaryText="Custom…" />
        </SelectField>
        {showCustomInput && (
          <TextField
            id={id ? `${id}-custom` : undefined}
            value={value || ''}
            onChange={this.handleCustomChange}
            hintText="Enter custom model name"
            fullWidth={fullWidth}
            disabled={disabled}
            style={style}
          />
        )}
      </div>
    );
  }
}

export default ModelPicker;



// WEBPACK FOOTER //
// ./src/components/basic/ModelPicker.js